export const getClientNameByClientId = (clientId: string) => {
  switch (clientId) {
    case "65c24d627fb62e500f400c62":
    case "65a510cd9415d41b1aa933dc":
      return "OH";
    default:
      return "DEFAULT";
  }
};
